import React from 'react';
import PropTypes from 'prop-types';
import { IconWarning, dlsColorWarning } from '@americanexpress/dls-react';
import { FxJourneyCompletionPage, FxMultiButtons } from 'axp-fx-common';

const CONFLICT_MESSAGE =
  'We found that your email address is already linked to another American Express product that can\'t be connected to FileXpress. To continue, return to the Welcome page to sign up with a new account.';
/**
 * Shown when the enrollment to SFT product returns RESP416 (enrollment conflict).
 * A single CTA sends the user back through the sign-up journey (to the Welcome page)
 * via the RSVP/redemption URL supplied by the caller.
 */
const EnrollmentConflictPage = ({ onContinueClick }) => {
  const actions = (
    <FxMultiButtons
      primaryButtonLabel="Back to Welcome Page"
      onPrimaryButtonClick={onContinueClick}
      justifyButtons="center"
    />
  );

  return (
    <FxJourneyCompletionPage
      status="failed"
      icon={<IconWarning size="lg" theme={dlsColorWarning} />}
      heading="Unable to Complete FileXpress Enrollment"
      details={CONFLICT_MESSAGE}
      actions={actions}
    />
  );
};

EnrollmentConflictPage.propTypes = {
  onContinueClick: PropTypes.func.isRequired,
};

export default EnrollmentConflictPage;
